<div class="top-bar position-fixed">
    <div class="row align-items-center">
        <div class="col-2">
            <img *ngIf="logoSrc" [src]="logoSrc" alt="Logo" class="platform-logo" />
        </div>
        <div class="col"></div>
        <div class="col-2 text-end">
            <p-button
                label="Se connecter"
                icon="pi pi-sign-in"
                class="p-button-primary"
                (click)="onLogin()"
            ></p-button>
        </div>
    </div>
</div>
